import React, { Fragment } from 'react';
import { Accordion, Divider } from 'semantic-ui-react';
import { AccordionProps } from '../../interfaces/AccordionProps';
import POSIcon from '../POSIcon';
import './AccordionContainer.less';

export type Props = AccordionProps;

export const AccordionContainer = ({
  index,
  activeIndex,
  title,
  content,
  headerIconPosition,
  onAccordionClick,
}: Props) => (
  <Fragment>
    <Accordion.Title
      className="pos-accordion"
      onClick={() => onAccordionClick(index)}
      index={index}
      active={activeIndex?.includes(index)}
    >
      <POSIcon
        icon={activeIndex?.includes(index) ? 'arrow-up' : 'arrow-down'}
        className={'float-' + headerIconPosition}
      />
      {title}
      <Divider />
    </Accordion.Title>
    <Accordion.Content active={activeIndex?.includes(index)}>
      {content}
    </Accordion.Content>
  </Fragment>
);
